import { useMemoizedFn } from "ahooks";
import { useRef } from "react";
import type { VoiceContext, VoiceTurn } from "./type";

export type VoiceRecognitionResult = VoiceTurn & {
  audioBlob?: Blob;
};

export function useCurrentMessageVoiceState() {
  const turnsRef = useRef<VoiceTurn[]>([]);

  const appendTurn = useMemoizedFn((turn: VoiceTurn) => {
    turnsRef.current = [...turnsRef.current, turn];
  });

  const resetVoiceState = useMemoizedFn(() => {
    turnsRef.current = [];
  });

  const buildVoiceContext = useMemoizedFn((): VoiceContext | undefined => {
    if (turnsRef.current.length === 0) {
      return undefined;
    }

    return {
      turns: [...turnsRef.current],
    };
  });

  return {
    appendTurn,
    resetVoiceState,
    buildVoiceContext,
    hasVoiceTurns: () => turnsRef.current.length > 0,
  };
}
